import React from "react";
import { Sidebar } from "../../components/Sidebar";
import AppLauncher from "../../components/AppLauncher";
import { LegalFooter } from "../../components/LegalFooter";

const Dashboard: React.FC = () => {
  return (
    <div className="min-h-screen w-screen bg-[#b9daf9]">
      <Sidebar />
      <main className="flex min-h-screen flex-col md:ml-[100px]">
          <AppLauncher />
        <footer className="">
          <LegalFooter />
        </footer>
      </main>
    </div>
  );
};

export default Dashboard;
